import Image from 'next/image';

const BobLight = () => (
  <Image
    src="/keepsimple_/assets/home-page/bob-light.png"
    alt="Bob Light"
    width={70}
    height={70}
  />
);

export default BobLight;
